import { Component } from '@angular/core';

/**
 * Generated class for the InitPageViewComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'init-page-view',
  templateUrl: 'init-page-view.html'
})
export class InitPageViewComponent {

  text: string;

  constructor() {
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/init-page-view/init-page-view.ts